import { ProductTileFeature } from "@omni/types/api/product/bff/shared/productTileFeature.model";
import { KeyFeatures } from "@omni/ui/components/Product/Feature/KeyFeatures/keyFeatures";
import { ProductTileStyle } from "@omni/ui/components/Product/ProductTile/productTile.style";
import { cn } from "@omni/utils/styles";

export type ProductTileDescriptionProps = {
    items?: ProductTileFeature[];
    showItems: boolean;
    amountOfFeatures: number;
    className?: string;
};

const ProductTileDescription = ({
    items,
    showItems,
    amountOfFeatures,
    className
}: ProductTileDescriptionProps) => {
    if (!items?.length || !amountOfFeatures || !showItems) return;

    const visibleFeatures = items
        .slice(0, amountOfFeatures)
        .map((feature) => ({ ...feature, coreFeature: true }));

    return (
        <KeyFeatures
            className={cn(className)}
            features={visibleFeatures}
            amountOfFeatures={amountOfFeatures}
        >
            <KeyFeatures.Features className={cn("tw:text-sm tw:mb-0 tw:pl-0")}>
                <KeyFeatures.Feature className={ProductTileStyle.description()}>
                    <KeyFeatures.Feature.Name />
                    {": "}
                    <KeyFeatures.Feature.Value />
                </KeyFeatures.Feature>
            </KeyFeatures.Features>
        </KeyFeatures>
    );
};

export { ProductTileDescription };
